import { useCallback, useState } from 'react';

export type AudienceRequestPayload = {
  name: string;
  email: string;
  company?: string;
  audience_name?: string;
  audience_category?: string;
  country_selected?: string;
  platform_name?: string;
  campaign_start_date?: string;
  campaign_end_date?: string;
  seat_name?: string;
  seat_id?: string;
  ad_type?: string;
};

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'https://api.digiseg.net').replace(/\/+$/, '');
const AUDIENCE_REQUEST_ENDPOINT = `${API_BASE_URL}/communications/audience_requests`;

export const useSubmitAudienceRequest = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const submit = useCallback(async (payload: AudienceRequestPayload) => {
    setIsSubmitting(true);
    setError(null);
    try {
      const res = await fetch(AUDIENCE_REQUEST_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        throw new Error(`Audience request failed: ${res.status} ${res.statusText}`);
      }
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  return { submit, isSubmitting, error };
};
